import { ChangeEvent, useCallback, useEffect, useRef } from 'react';

export function useCheckboxGroup(errorMessage: string) {
  const elementRef = useRef<HTMLInputElement | null>(null);
  const numberOfSelectedCheckBoxes = useRef(0);

  const setCustomValidity = useCallback(() => {
    if (numberOfSelectedCheckBoxes.current > 0) {
      elementRef.current?.setCustomValidity('');
    } else {
      elementRef.current?.setCustomValidity(errorMessage);
    }
  }, [errorMessage]);

  const setElementRef = useCallback((node: HTMLInputElement | null) => {
    if (!elementRef.current) {
      elementRef.current = node;
    }
  }, []);

  useEffect(() => {
    setCustomValidity();
  });

  const onCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      numberOfSelectedCheckBoxes.current += event.target.checked ? +1 : -1;
      setCustomValidity();
    },
    [setCustomValidity],
  );

  return {
    setElementRef,
    onCheckboxChange,
  };
}
